import { Card } from "@/components/ui/Card";
import { cn } from "@/lib/cn";
import type { LucideIcon } from "lucide-react";

export interface StatCardProps {
  icon: LucideIcon;
  label: string;
  value: string | number;
  unit?: string;
  color?: "accent" | "warning" | "danger" | "text" | "text-muted";
  testId?: string;
  className?: string;
}

export function StatCard({
  icon: Icon,
  label,
  value,
  unit,
  color = "text",
  testId,
  className,
}: StatCardProps) {
  const colorClass =
    color === "accent"
      ? "text-accent"
      : color === "warning"
      ? "text-warning"
      : color === "danger"
      ? "text-danger"
      : color === "text-muted"
      ? "text-text-muted"
      : "text-text";

  return (
    <Card
      data-testid={testId}
      className={cn("flex items-center gap-3 p-4", className)}
    >
      <div
        className={cn(
          "rounded-full bg-muted p-2",
          colorClass,
        )}
      >
        <Icon size={20} strokeWidth={2} />
      </div>
      <div className="flex flex-col">
        <span className="text-xs font-medium text-text-muted">{label}</span>
        <span className="text-lg font-semibold text-text">
          {value}
          {unit && (
            <span className="ml-0.5 text-xs font-normal text-text-muted">
              {unit}
            </span>
          )}
        </span>
      </div>
    </Card>
  );
}
